
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Footer from "@/components/Footer";
import WhatWeDoSection from "@/components/sections/WhatWeDoSection";
import CentralIllustrationSection from "@/components/sections/CentralIllustrationSection";
import WhyInvestSection from "@/components/sections/WhyInvestSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import CtaSection from "@/components/sections/CtaSection";
import { Helmet } from "react-helmet-async";

const Index = () => {
  // JSON-LD Schema data
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LocalUp",
    "url": "https://www.localup.com.br",
    "logo": "https://www.localup.com.br/logo.png",
    "description": "Especialistas em SEO Local para pequenas e médias empresas. Aumente sua visibilidade no Google e atraia mais clientes da sua região.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+5511951974403",
      "contactType": "customer service"
    },
    "sameAs": [
      "https://www.facebook.com/localupseo",
      "https://instagram.com/localupseo",
      "https://linkedin.com/company/localup"
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "LocalUp",
    "image": "https://www.localup.com.br/logo.png",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "addressCountry": "BR"
    },
    "telephone": "+5511951974403",
    "url": "https://www.localup.com.br"
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "LocalUp - SEO Local para Pequenas e Médias Empresas",
    "url": "https://www.localup.com.br",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.localup.com.br/busca?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>LocalUp - SEO Local para Pequenas e Médias Empresas</title>
        <meta name="description" content="Serviços de SEO Local para pequenas e médias empresas. Aumente sua visibilidade no Google e atraia mais clientes da sua região." />
        <meta name="keywords" content="SEO local, marketing local, Google Meu Negócio, visibilidade local, SEO para pequenas empresas" />
        <link rel="canonical" href="https://www.localup.com.br" />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
      </Helmet>
      <Navbar />
      <Hero />
      <WhatWeDoSection />
      <CentralIllustrationSection />
      <WhyInvestSection />
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Index;
